<template >
  <div>
      <div>
      <OuterHeader ref="OuterHeader" @showRegister="showRegister()" />
    </div>
    <main role="main">
      <div class="page-content mt-0">
        <section class="innerpage-banner mb-5 banner-our-Procedure">
          <div class="container">
            <div class="row align-items-center content-wrap">
              <div class="col-lg-7 col-md-12">
                <h1 class="text-white display-4 font-bold">Our Procedure</h1>
              </div>
            </div>
          </div>
        </section>
        <div class="container my-md-5 mb-4">
          <div class="row pt-md-5 pt-4 mt-4">
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <!-- <svg class="icon" width="95">
                        <use xlink:href="images/procedure-icons.svg#register"></use>
                        </svg> -->

                  <img src="images/register.svg" width="95" />
                </div>
                <p class="font-16 mt-3">Free Register <br />your Profile</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img src="images/search.svg" width="95" height="95" alt="" />
                </div>
                <p class="font-16 mt-3">Free Search <br />All Profiles</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img
                    src="images/become-membership.svg"
                    width="95"
                    height="95"
                    alt=""
                  />
                </div>
                <p class="font-16 mt-3">
                  Become a member , if you like profiles & our features
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img
                    src="images/matching.svg"
                    width="95"
                    height="95"
                    alt=""
                  />
                </div>
                <p class="font-16 mt-3">
                  See detail profile with kundali matching score
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img
                    src="images/send-recive.svg"
                    width="95"
                    height="95"
                    alt=""
                  />
                </div>
                <p class="font-16 mt-3">
                  Send & Receive<br />
                  Interest
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img
                    src="images/view-contact.svg"
                    width="95"
                    height="95"
                    alt=""
                  />
                </div>
                <p class="font-16 mt-3">
                  View Contacts<br />
                  Immediately
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5 pb-md-5 pb-4">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img
                    src="images/handpiked-profile.svg"
                    width="95"
                    height="95"
                    alt=""
                  />
                </div>
                <p class="font-16 mt-3">
                  Get Handpicked<br />
                  Profiles From Us
                </p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-5">
              <div class="card p-3 border-0 shadow text-center prodcess-card">
                <div class="text-center icon-wrap">
                  <img src="images/meet.svg" width="95" height="95" alt="" />
                </div>
                <p class="font-16 mt-3">
                  Meet Your Dream Partner <br />at preferred location.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <SubFooter  ref="SubFooter" @showRegister="showRegister()"/>
     <SignUp ref="signupModal" />
    <MainFooter />
  </div>
</template>
<script>
import OuterHeader from "@/components/OuterHeader";
// import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";
import SubFooter from "@/components/SubFooter";
 import SignUp from "../../components/signup.vue";
export default {
  name: "OurProcedure",
  components: {
    OuterHeader,
    // InnerHeader,
    MainFooter,
    SubFooter,
    SignUp
  },
  data() {},
  mounted() {},
  methods: {
     showRegister() {
      this.$refs.signupModal.showModal();
    },
  },
};
</script>
